'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ItemFacetsRemote = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _helpers = require('./helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ItemFacetsRemote = exports.ItemFacetsRemote = {
    fetchItemFacets: function fetchItemFacets(_ref) {
        var authToken = _ref.authToken,
            deployment = _ref.deployment,
            ids = _ref.ids;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)('<ITEM-API>spa/small/item-facets', deployment);
            (0, _helpers.addAuthToken)(request, authToken);
            request.send({ ids: ids });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)(resolve, reject, err, response);
            });
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/remote/itemFacets.js
// module id = 3aW2
// module chunks = 46